<template>
    <div class="node-container">
        <!-- 电梯导航 -->
        <div class="elevator-nav">
            <ul class="item-wrap">
                <li v-if="type != 'preview' && isCurrent" class="active" @click="addMeeting"><i class="el-icon-plus"></i>新增会议</li>
                <li v-for="(item, index) in meeting" :key="item.id">第{{ meeting.length - index }}次会议</li>
            </ul>
        </div>
        <!-- 会议列表 -->
        <div class="metting-wrap" v-loading="loadFull">
            <template v-if="meeting.length">
                <div class="item-wrap" v-for="(item, index) in meeting" :key="item.id">
                    <div class="title-line">
                        <span>第{{ meeting.length - index }}次会议</span>
                        <template v-if="type != 'preview' && isCurrent">
                            <i class="el-icon-document-checked" v-if="item.editFlag" @click="saveMeeting(item)">保存</i>
                            <i class="el-icon-edit" v-else @click="changeEditFlag(item, true)">编辑</i>
                            <i class="el-icon-delete red" @click="deleteMeeting(item, index)">删除</i>
                        </template>
                    </div>
                    <div class="line-box">
                        <label>会议日期</label>
                        <div class="form-box" v-if="item.editFlag">
                            <el-date-picker v-model="item.meetingDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" size="small" style="width: 100%;" />
                        </div>
                        <div class="value-box" v-else>{{ item.meetingDate }}</div>
                    </div>
                    <div class="line-box">
                        <label>参会人员</label>
                        <div class="form-box" v-if="item.editFlag">
                            <el-input v-model="item.meetingUser" placeholder="请输入参会人员" size="small" maxlength="100" show-word-limit />
                        </div>
                        <div class="value-box" v-else>{{ item.meetingUser }}</div>
                    </div>
                    <div class="line-box">
                        <label>会议内容</label>
                        <div class="form-box" v-if="item.editFlag">
                            <el-input v-model="item.content" type="textarea" placeholder="请输入会议内容" :autosize="{ minRows: 2, maxRows: 6}" maxlength="1000" show-word-limit
                                size="small" />
                        </div>
                        <div class="value-box" v-else>{{ item.content }}</div>
                    </div>
                    <div class="line-box">
                        <label>会议结果</label>
                        <div class="form-box" v-if="item.editFlag">
                            <el-input v-model="item.result" placeholder="请输入会议结果" size="small" maxlength="100" show-word-limit />
                        </div>
                        <div class="value-box" v-else>{{ item.result }}</div>
                    </div>
                    <div class="line-box">
                        <label>会议附件</label>
                        <div class="form-box">
                            <uploadAtt v-model="item.fileInfoModelList" :bizType="2" :disabled="!item.editFlag || !isCurrent || type == 'preview'" />
                        </div>
                    </div>
                </div>
            </template>
            <!-- 暂无数据 -->
            <h2 v-else style="text-align: center; margin-top: 150px; color: #a5a5a5;">暂无会议记录</h2>
        </div>
        <!-- 底部按钮 -->
        <div class="footer-operation" v-if="type != 'preview' && isCurrent">
            <el-button @click="onRollback">上一步</el-button>
            <el-button type="primary" :loading="loadSubmit" @click="onSubmit" icon="el-icon-check">通过</el-button>
            <el-button type="primary" plain icon="el-icon-close" @click="onRefuse">不通过</el-button>
        </div>
    </div>
</template>

<script>
import { findRequirementMeetingList, addRequirementMeeting, updateRequirementMeeting, deleteRequirementMeeting, refuseRequirement } from '@/api/requirement'

export default {
    components: {
        uploadAtt: () => import("./uploadAtt.vue")
    },
    props: {
        requirementId: [Number, String],
        currentStep: [Number, String],
        // 弹窗类型：add 新增 | edit 编辑 | preview 预览
        type: String,
    },
    data() {
        return {
            meeting: [],
            loadFull: false,
            loadSubmit: false
        }
    },
    computed: {
        // 倒序展示会议列表
        // meetingReverse() {
        //     return this.meeting.slice().reverse()
        // },
        // 进度是否为当前节点
        isCurrent() {
            return this.currentStep === 2 ? true : false
        }
    },
    methods: {
        // 新增一个空会议
        addMeeting() {
            let emptyItem = {
                meetingDate: '',
                meetingUser: '',
                content: '',
                result: '',
                fileInfoModelList: [],
                editFlag: true // 是否处于表单输入状态
            };
            this.meeting.unshift(emptyItem);
        },
        // 开启/关闭编辑模式 单条会议
        changeEditFlag(item, flag) {
            this.$set(item, 'editFlag', flag);
        },
        // 删除会议
        deleteMeeting(item, index) {
            if (item.id) {
                this.loadFull = true;
                deleteRequirementMeeting({
                    requirementId: this.requirementId,
                    meetingId: item.id
                }).then(() => {
                    this.loadFull = false;
                    this.echoInfo();
                }).catch(err => {
                    this.loadFull = false;
                    this.$MessageBox.MessageWarning(err.data.msg);
                })
            } else {
                this.meeting.splice(index, 1);
            }
        },
        // 回显表单信息
        echoInfo() {
            if (!this.requirementId) return;
            findRequirementMeetingList({ requirementId: this.requirementId }).then(res => {
                // 后台返回的会议列表是倒序
                this.meeting = this.$utils.deepCopy(res.data) || [];
                this.meeting.forEach(item => {
                    let list = item.fileInfoModelList.map(x => {
                        return {
                            uid: x.id,
                            name: x.fileName,
                            path: x.filePath,
                            id: x.id,
                        }
                    })
                    this.$set(item, 'fileInfoModelList', list)
                })
            }).catch(err => {
                this.meeting = [];
                this.$MessageBox.MessageWarning(err.data.msg);
            })
        },
        // 提交表单
        saveMeeting(item) {
            this.loadFull = true;
            // 表单校验
            if (!(item.meetingDate && item.meetingUser && item.content)) {
                this.$MessageBox.MessageWarning('请填写完整会议信息');
                this.loadFull = false;
                return false;
            }
            // 新增or编辑接口
            let reqApi = addRequirementMeeting;
            if (item.id) {
                reqApi = updateRequirementMeeting;
            }
            // 处理参数
            item.fileIdList = item.fileInfoModelList.map(x => x.id);
            // 请求
            reqApi({ id: this.requirementId, meeting: item }).then(res => {
                if (res.data) {
                    item.id = res.data;
                }
                this.loadFull = false;
                this.changeEditFlag(item, false);
                this.$MessageBox.MessageSuccess(res.msg);
            }).catch(err => {
                this.loadFull = false;
                this.$MessageBox.MessageWarning(err.data.msg);
            })
        },
        // 点击同意 推进步骤
        onSubmit() {
            this.loadSubmit = true;
            let valid = this.formValidate(); // 表单校验
            if (valid) {
                // 推进步骤
                this.$emit('push');
                this.loadSubmit = false;
            } else {
                this.loadSubmit = false;
                this.$MessageBox.MessageWarning('请保存您填写会议信息');
            }
        },
        // 点击“上一步” 回退步骤
        onRollback() {
            let valid = this.formValidate(); // 表单校验
            if (valid) {
                this.$emit('rollback');
            } else {
                this.$confirm('您填写的会议信息尚未保存, 是否继续返回上一步?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$emit('rollback');
                }).catch(() => { });
            }
        },
        // 点击“不同意” 回退步骤
        onRefuse() {
            let valid = this.formValidate(); // 表单校验
            if (valid) {
                refuseRequirement({ requirementId: this.requirementId }).then(res => {
                    this.$MessageBox.MessageSuccess(res.msg);
                }).catch(err => {
                    this.$MessageBox.MessageWarning(err.data.msg);
                })
            } else {
                this.$MessageBox.MessageWarning('请保存您填写会议信息');
            }
        },
        // 表单校验：会议编辑的内容是否都保存了
        formValidate() {
            let valid = true;
            this.meeting.forEach(item => {
                if (item.editFlag) {
                    valid = false
                }
            })
            return valid;
        }
    }
}
</script>

<style lang="scss" scoped>
.node-container {
    position: relative;
    display: flex;
    flex-direction: column;
    min-height: 400px;
    .elevator-nav {
        position: absolute;
        left: 4%;
        top: 0;
        .item-wrap {
            display: flex;
            flex-direction: column;
            list-style: none;
            padding: 0;
            margin: 0;
            > li {
                height: 34px;
                padding: 0 18px;
                color: #333;
                background-color: #f2f3f7;
                line-height: 34px;
                text-align: center;
                margin-bottom: 1px;
                cursor: pointer;
            }
            li.active {
                background-color: #0540c3;
                color: #fff;
                i {
                    margin-right: 3px;
                    font-size: 12px;
                    vertical-align: 1px;
                    font-weight: 600;
                }
            }
        }
    }
}
.metting-wrap {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 550px;
    margin: 0 auto 30px auto;
    .item-wrap {
        position: relative;
        display: flex;
        flex-direction: column;
        gap: 10px;
        .title-line {
            position: relative;
            display: flex;
            align-items: center;
            gap: 12px;
            margin-bottom: 10px;
            color: #0540c3;
            font-size: 1.2rem;
            font-weight: 600;
            &::before {
                content: "";
                position: absolute;
                top: 10px;
                left: -23px;
                width: 6px;
                height: 6px;
                background-color: #fff;
                border-radius: 50%;
                border: 2px solid #0540c3;
            }
            > i {
                margin-top: 3px;
                font-size: 15px;
                cursor: pointer;
                vertical-align: -2px;
                // border: 1px solid #0540c3;
            }
            .red {
                color: #ed0505;
            }
        }
        .line-box {
            position: relative;
            display: flex;
            gap: 10px;
            min-height: 32px;
            > label {
                width: 90px;
                min-width: 90px;
                margin-top: 5px;
                color: #333;
            }
            .form-box {
                width: calc(100% - 100px);
            }
            .value-box {
                padding-top: 5px;
            }
            &::before {
                content: "";
                position: absolute;
                top: 12px;
                left: -22px;
                width: 6px;
                height: 6px;
                background-color: #c4c6cc;
                border-radius: 50%;
            }
        }
        &::before {
            content: "";
            position: absolute;
            left: -20px;
            top: 10px;
            bottom: 0;
            width: 2px;
            background-color: #e6e6e6;
        }
    }
}
.footer-operation {
    display: flex;
    justify-content: center;
    margin-top: auto;
    margin-bottom: 0;
    > .el-button {
        height: 32px;
        line-height: 31px;
        padding-top: 0;
        padding-bottom: 0;
    }
}
</style>